/* import __COLOCATED_TEMPLATE__ from './workflow-type-cell.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import Component from '@glimmer/component';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';

interface WorkflowContentData {
  parallel?: boolean;
  has_fin_step?: boolean;
}

interface ContentFragment {
  contentData?: WorkflowContentData;
  contentType?: number;
}

interface ContentCollection {
  firstObject?: ContentFragment;
  length?: number;
}

interface ContentWrapper {
  contents?: ContentCollection;
}

export interface Args {
  wrapper: ContentWrapper;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class WorkflowTypeCellComponent extends Component<Signature> {
  private get contentData(): WorkflowContentData | null {
    if (!this.args?.wrapper?.contents?.length) {
      return null;
    }
    return this.args.wrapper.contents.firstObject?.contentData as WorkflowContentData;
  }

  get isBackgroundWorkflow(): boolean {
    return this.contentData?.parallel === true;
  }

  get isWorkflowWithFin(): boolean {
    return this.contentData?.has_fin_step === true || this.isAiAgentWorkflow;
  }

  get isAiAgentWorkflow(): boolean {
    let contentType = this.args.wrapper.contents?.firstObject?.contentType;
    return contentType === objectTypes.triggerableCustomBot;
  }

  get isInteractiveWorkflow(): boolean {
    return !this.isBackgroundWorkflow && !this.isWorkflowWithFin;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Outbound::List::WorkflowTypeCell': typeof WorkflowTypeCellComponent;
    'outbound/list/workflow-type-cell': typeof WorkflowTypeCellComponent;
  }
}
